// Filtres par categorie pour la page blog

import { categories, CategoryType } from "@/data/articles";

interface BlogFiltersProps {
  activeCategory: CategoryType;
  onCategoryChange: (category: CategoryType) => void;
}

const BlogFilters = ({ activeCategory, onCategoryChange }: BlogFiltersProps) => {
  return (
    <section className="py-8 bg-[#0F172A]">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center gap-3">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => onCategoryChange(category)}
              className={`
                px-4 py-2 rounded-full text-sm font-medium transition-all duration-200
                ${activeCategory === category
                  ? 'bg-[#F59E0B] text-[#0A0A0F] shadow-[0_2px_10px_rgba(245,158,11,0.3)]'
                  : 'bg-transparent border border-white/20 text-white/60 hover:border-[#F59E0B]/50 hover:text-white'
                }
              `}
            >
              {category}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogFilters;
